import Config from "../../assets/js/config";

const config = new Config();

const scrollToAnchor = (anchor) => {
    $('html, body').stop().animate({
        scrollTop: $(anchor).offset().top - 140
    }, 1000);
};

class FormErrorConstants {
    constructor(selector) {
        this.constants = {
            auth_login: 'Login gegevens onjuist.',
            newemail: 'Er is geen e-mailadres ingevuld.',
            failed_verification: 'Captcha gegevens onjuist',
            email_exist: 'Jouw e-mailadres is al bekend in ons systeem.' +
                'Wil je jouw orders overzichtelijk op één account, log dan in met ' +
                'jouw wachtwoord of <a href="/?action=auth/login&recoverPassword=1">vraag een nieuw wachtwoord aan</a> voor jouw account.',
            user_name: 'Gelieve jouw naam in te vullen',
            last_name: 'Achternaam niet juist. Het veld is verplicht',
            zip: 'Postcode niet juist. Het veld is verplicht',
            zip_nl: "Postcode voor het gekozen land moet 4 getallen en 2 letters bevatten",
            zip_be: "Postcode voor het gekozen land moet 4 getallen bevatten",
            nbr: 'Huisnummer niet juist. Het veld is verplicht',
            street: 'Straat niet juist. Het veld is verplicht',
            city: 'Plaats niet juist. Het veld is verplicht',
            country: 'Land niet juist. Het veld is verplicht',
            phone: 'Gelieve een telefoonnummer in te vullen, zodat wij contact kunnen opnemen bij bijzonderheden',
            email: 'Gelieve een juist e-mailadres in te vullen, zodat wij jouw vraag snel kunnen beantwoorden',
            description: 'Naam niet juist. Het veld is verplicht',
            passworderror: 'Wachtwoorden zijn niet gelijk',
            payment_adyen_error: "Gelieve alle velden in te vullen",
            payment_creditcard_not_set_child: 'Kies svp met welke creditcard je wilt betalen',
            nodeliverypoint: 'Je dient nog een afhaalpunt te selecteren',
            nopaymentmehod: 'Kies alstublieft een betaalmethode',
            retour_quantity_is_greater: 'Het is niet mogelijk om meer producten te retourneren dan dat er besteld zijn',
            retour_quantity_number: 'Voer het aantal in',
            field_required: 'Het veld is verplicht',
            minlength: 'Minimaal: {1} tekens lang',
            message_required: 'Er is geen persoonlijk bericht ingevuld.',
            regid: 'Email gegevens onjuist.',
            newpassworderror: 'Het ingevoerde wachtwoord moet minimaal 8 karakters bevatten waarvan minimaal 1 letter en 1 getal.',
            retour_excahnge_is_required: 'Het veld is verplicht',
            clang_newsletter_subscription_failed: 'Het opgegeven emailadres is niet correct. Probeer het opnieuw.',
            clang_newsletter_subscription_successful: 'Je bent succesvol ingeschreven voor onze nieuwsbrief',
            wishlist_email_success : 'Je bericht is succesvol verzonden',
            wishlist_email_error: 'Uw bericht is niet verzonden',
            nodeliverypoint_form: 'Je dient nog aan te geven hoe je je bestelling wenst te ontvangen',
            csrf_token_not_valid: 'Ongeldige Csrf-token gegevens. Herlaad de pagina',
            choose_another_size: 'Langere levertijd',
            product_not_found: 'Dit is geen juist artikelnummer. Vul het juiste artikelnummer in of gebruik het vrije veld hieronder.',
            currentPasswordMismatch: 'Het ingevoerde wachtwoord komt niet overeen met het huidige wachtwoord',
        };

        if (selector) {
            this.forms = $(selector);
        } else {
            this.forms = $('form.validate');
        }
    }

    formatString() {
        let args = [].slice.call(arguments);
        if (this.toString() !== '[object Object]') {
            args.unshift(this.toString());
        }

        let pattern = new RegExp(`{([1-${args.length}])}`, 'g');

        return String(args[0]).replace(pattern, function(match, index) {
            return args[index];
        });
    }

    init() {
        for (let i = 0; i < this.forms.length; i++) {
            let currentForm = $(this.forms[i]);
            let foundErrorElements = currentForm.find('[data-error]');

            for (let j = 0; j < foundErrorElements.length; j++) {
                let wrapFoundElement = $(foundErrorElements[j]);
                if (!wrapFoundElement.parent().next().hasClass('notice-error')) {
                    let messageConstant = wrapFoundElement.attr('data-error');
                    let message = this.constants.hasOwnProperty(messageConstant) ? this.constants[messageConstant] : messageConstant;
                    wrapFoundElement.parents('.column').removeClass('valid');
                    wrapFoundElement.parents('.column').addClass('error');
                    if (wrapFoundElement.attr('data-minlength')) {
                        message = this.formatString(message, wrapFoundElement.attr('data-minlength'))
                    }
                    wrapFoundElement.parent().after(this.getNoticeErrorHtml(message));
                    this.scrollToTopErrorContainer();
                }
            }
        }

        $(':input').change(event => {
            if (!$(event.target).attr('required') || $(event.target).attr('type') === 'email') {
                return;
            }
            $(event.target).parents('.column').removeClass('error');
            $(event.target).parents('.column').addClass('valid');
            if (!$(event.target).val().length) {
                $(event.target).parents('.column').removeClass('valid');
            }
            let errorDiv = $(event.target.parentElement.parentElement).find('.notice-error');
            if (errorDiv.length) {
                errorDiv.remove();
            }
        });

        let errorContainer = $('.notice-custom-error, .notice-error').first();
        if (errorContainer.length) {
            let errorInput = errorContainer.closest('.column');
            if (errorInput.length) {
                scrollToAnchor(errorInput);
            }
        }
    }

    scrollToTopErrorContainer() {
        const $shippingMethodForm = $('#shippingMethod');
        let errorContainer = $('.notice-error').first();
        if (errorContainer.length && !$shippingMethodForm.length) {
            scrollToAnchor(errorContainer);
        }
    }

    getNoticeErrorHtml(message) {
        return message ? `
            <div class="notice notice-error" data-added-error="${this.escapeKey(message)}">
                <div class="icon"><img src="${config.getDomain()}/svg/icon-error.svg" alt="Foutmelding"></div>
                <div class="text">${message}</div>
            </div>` : '';
    }

    showNoticeErrorAfter(element, elementAfter, message) {
        $(element).removeClass('valid').addClass('error');
        $(elementAfter).nextAll(`.notice.notice-error[data-added-error="${this.escapeKey(message)}"]`).remove();
        $(elementAfter).after(this.getNoticeErrorHtml(message));
    }

    escapeKey(str) {
        return str.replace(/[^a-z0-9_-]/gi, '_');
    }

    hideNoticeErrorNext(element, noticeError) {
        $(element).removeClass('error');
        $(noticeError).next('.notice-error').remove();
        $(element).addClass('valid');
    }

    /**
     *
     * @param collection
     * @returns {boolean}
     */
    validateInputElementCollection(collection) {
        let checkValidation = true;
        collection.each(function (index, element) {
            let _element = $(element);
            let parent = _element.parent();

            if (_element.is('input')) {
                checkValidation = false;
                if (_element.is(':checked')) {
                    checkValidation = true;
                    return false;
                }
            }

            if (_element.is('text')) {
                if (_element.val().length  === 0) {
                    checkValidation = false;
                    return false;
                }
            }
        });

        return checkValidation;
    }

    removeErrors(form) {
        form.find('.notice-error').remove();
    }

    removeDataError(form) {
        form.find('input[data-error]').each(function (i, element) {
            $(element).removeAttr('data-error');
        })
    }

    getConstant(key) {
        return this.constants[key] || '';
    }
}

export default FormErrorConstants;
